export default __webpack_public_path__ + "static/media/ViewPatientCts.68d3003a.svg";